function clarify(input) {
  let output = '';

  // Loop through each character in the input string
  for (let i = 0; i < input.length; i++) {
      let char = input[i];

      // If the character is a letter (uppercase or lowercase)
      if (/[a-zA-Z]/.test(char)) {
          let ascii = char.charCodeAt(0);
          let base = (char >= 'a' && char <= 'z') ? 'a'.charCodeAt(0) : 'A'.charCodeAt(0);

          // Subtract 19 positions to reverse the ROT19 transformation
          let newChar = String.fromCharCode(base + ((ascii - base - 19 + 26) % 26)); // +26 ensures positive values
          output += newChar;
      }
      // If the character is a digit
      else if (/\d/.test(char)) {
          let ascii = char.charCodeAt(0);
          // Reverse the digit shift (subtracting 19 from the digit)
          let newChar = String.fromCharCode(48 + ((ascii - 48 - 19 + 10) % 10)); // +10 ensures positive values
          output += newChar;
      }
      // Non-alphabetic characters (special characters, etc.) are added as-is
      else {
          output += char;
      }
  }

  return output;
}


function process_emails() {

  // @ts-ignore
  if (!window.tms.clarify) { return; }
  



  const to_replace: Array<any> = [];

  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;


  // Text walker
  const textWalker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);

  // Track text 
  while (textWalker.nextNode()) {
    let node = textWalker.currentNode;
    
    let matches = node?.nodeValue?.match(emailRegex);

    if (matches) {
      
      matches.forEach(email => {
        to_replace.push({node, email});
      });
    }

  }

  // Link walker
  const linkWalker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, null);

  // Track text 
  while (linkWalker.nextNode()) {
    let node = linkWalker.currentNode as HTMLElement;
    
    if (node.tagName === 'A') {
      let matches = node?.getAttribute('href')?.match(emailRegex);

      if (matches) {
        
        matches.forEach(email => {
          to_replace.push({node, email});
        });
      }
    }

  }


  // Then replace, to avoid issues with the walker
  to_replace.forEach( ({node, email}: {node: any, email: string}) => {
    
    // const parent = node.parentNode;
    const newEmail = clarify(email);
    // const href = parent.getAttribute('href');

    // Set text content only
    if (node.data) {
      node.data = node.data.replace(email, newEmail);
    }

    // Set href  only
    if (node.tagName === 'A') {
      node.setAttribute('href', node.getAttribute('href').replace(email, newEmail));
    }
    

  });

}

document.addEventListener('DOMContentLoaded', function() {
  process_emails();
});


